import React from 'react';
import { Card } from 'antd';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const UsageTrendChart = ({ data = [] }) => {
  const chartData = data;

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div style={{
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }}>
          <p style={{ margin: 0, fontWeight: 'bold' }}>{label}</p>
          {payload.map((entry, index) => (
            <p key={index} style={{ margin: 0, color: entry.color }}>
              {entry.name}: {entry.value}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  // Eğer veri yoksa boş state göster
  if (!chartData || chartData.length === 0) {
    return (
      <Card title="Günlük Kullanım Trendi">
        <div style={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999' }}>
          Veri bulunamadı
        </div>
      </Card>
    );
  }

  return (
    <Card title="Günlük Kullanım Trendi" style={{ height: '100%' }}>
      <ResponsiveContainer width="100%" height={280}>
        <LineChart data={chartData} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" style={{ fontSize: '12px' }} />
          <YAxis yAxisId="left" style={{ fontSize: '12px' }} />
          <YAxis yAxisId="right" orientation="right" style={{ fontSize: '12px' }} />
          <Tooltip content={<CustomTooltip />} />
          <Legend 
            wrapperStyle={{ fontSize: '12px', paddingTop: '10px' }}
          />
          <Line
            yAxisId="left"
            type="monotone"
            dataKey="shots"
            stroke="#1890ff"
            strokeWidth={2}
            name="Atış Sayısı"
            dot={{ fill: '#1890ff', strokeWidth: 2, r: 3 }}
          />
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="devices"
            stroke="#52c41a"
            strokeWidth={2}
            name="Aktif Cihaz"
            dot={{ fill: '#52c41a', strokeWidth: 2, r: 3 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default UsageTrendChart;
